import React, { useState, useRef } from "react";
import * as Cookie from "js-cookie";
import { useHistory } from "react-router-dom";
import { Constants } from "../../constants/appConstants";
import { configService } from "../../services/configService";
import AccountDetails from "./AccountDetails";
import DCCutoffCount from "../dcCutoffCount/DCCutoffCount";
import Modal from "../modalContent/ModalContent";
import ModalCenter from "../modalContentCenter/ModalContentCenter";
import "./Header.css";

const Header: React.FC = () => {
  const history = useHistory();
  const config = configService.getConfig();
  const userId = Cookie.get("userId") || "";

  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showDCCutoffModal, setShowDCCutoffModal] = useState(false);
  const accountRef = useRef<{ getAccountDetailData: () => void }>(null);
  const dcCutoffRef = useRef<{ getDCCutoffData: () => void }>(null);

  const logout = () => {
    Cookie.remove("userId");
    document.cookie = config.deleteUserIdCookie + new Date(0).toUTCString();
    document.cookie = config.deleteAccessTokenCookie + new Date(0).toUTCString();
    history.push("/unauthorized");
  };

  const openAccountSelection = () => {
    setShowAccountModal(true);
  };

  const openDCCutoff = () => {
    setShowDCCutoffModal(true);
  };

  React.useEffect(() => {
    if (showAccountModal) {
      accountRef.current?.getAccountDetailData();
    }
  }, [showAccountModal]);

  React.useEffect(() => {
    if (showDCCutoffModal) {
      dcCutoffRef.current?.getDCCutoffData();
    }
  }, [showDCCutoffModal]);

  return (
    <div id="header">
      <div className="container header-width">
        <div className="row">
          <div className=" header-section-contrainer col-lg-8 col-md-6 col-sm-6 col-6 logo-section">
            <img className="cardinal-logo-img" src="/assets/images/logo-main.png" alt="Cardinal Health" />
            <span className="order-express">{Constants.ORDER_EXPRESS}</span>
          </div>
          <div className="welcome header-section-contrainer col-lg-4 col-md-6 col-sm-6 col-6">
            <div>
              <span className="welcome-section">{Constants.WELCOME}</span>
              <span className="welcome-section"> {userId}</span><br />
              <span>
                <a className="logout-link" onClick={logout}>
                  {Constants.LOGOUT}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="separator"></div>
      <div className="centralize-section">
        <div className="row">
          <div className="header-section-contrainer col-lg-6 col-md-6 col-sm-6 col-6">
            <span className="centralize-heading">{Constants.CENTARLIZED_CSOS}</span>
          </div>
          <div className="header-section-contrainer col-lg-6 col-md-6 col-sm-6 col-6 centralize-right-section">
          <div>
            <a className="CSOS-admin" onClick={openAccountSelection}>
              {Constants.CSOS_ADMIN}
            </a>
          </div>
          <div>
            <a className="DC-cutoffCount" onClick={openDCCutoff}>
              {Constants.DC_CUTOFF}
            </a>
            </div>
          </div>
        </div>
      </div>
      <ModalCenter visible={showAccountModal}>
        <AccountDetails ref={accountRef} onClose={() => setShowAccountModal(false)} />
      </ModalCenter>
      <Modal visible={showDCCutoffModal}>
        <DCCutoffCount ref={dcCutoffRef} onClose={() => setShowDCCutoffModal(false)} />
      </Modal>
    </div>
  );
};

export default Header;
